import axios from "../plugins/parseAxios";
export class AssetCategoryAPI {
  static getAssetCategory(payload) {
    return axios.post("functions/getAssetCategory", payload);
  }
  static getAssetCategories(payload) {
    return axios.post("functions/getAssetCategories", payload);
  }
  static updateAssetCategory(payload) {
    return axios.post("functions/updateAssetCategory", payload);
  }
  static removeAssetCategory(payload) {
    return axios.post("functions/removeAssetCategory", payload);
  }
  static createAssetCategory(payload) {
    return axios.post("functions/createAssetCategory", payload);
  }
}
